import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import User from 'flarum/common/models/User';
import CommentPost from 'flarum/forum/components/CommentPost';

// Ranks are earned by posting. Staff get their own look regardless of post count.
// Thresholds are tuned to this forum (13 members have 10+ posts, 3 have 25+).
export const RANKS = [
  { key: 'legend', min: 50, label: 'Legend', icon: 'fas fa-crown' },
  { key: 'veteran', min: 25, label: 'Veteran', icon: 'fas fa-medal' },
  { key: 'enthusiast', min: 10, label: 'Enthusiast', icon: 'fas fa-fire' },
  { key: 'regular', min: 5, label: 'Regular', icon: 'fas fa-star' },
  { key: 'newcomer', min: 0, label: 'Newcomer', icon: 'fas fa-seedling' },
];
const STAFF = {
  admin: { key: 'admin', label: 'Admin', icon: 'fas fa-shield-alt', title: 'Forum administrator' },
  mod: { key: 'mod', label: 'Moderator', icon: 'fas fa-bolt', title: 'Forum moderator' },
};

export function rankFor(total, groupIds = []) {
  const g = groupIds.map(String);
  if (g.includes('1')) return STAFF.admin;
  if (g.includes('4')) return STAFF.mod;
  const r = RANKS.find((x) => total >= x.min) || RANKS[RANKS.length - 1];
  return { ...r, title: `${r.label} · ${r.min}+ posts` };
}

export function userRank(user) {
  if (!user) return null;
  const groups = user.groups() || [];
  return rankFor(user.commentCount() || 0, groups.filter(Boolean).map((x) => x.id()));
}

export function rankPill(rank) {
  return (
    <span className={`RankPill RankPill--${rank.key}`} title={rank.title}>
      <i className={rank.icon} aria-hidden="true" /> {rank.label}
    </span>
  );
}

export default function addRanks() {
  // Pill beside the name on posts and user cards (both render user.badges()).
  extend(User.prototype, 'badges', function (items) {
    const rank = userRank(this);
    if (rank) items.add('jaecoo-rank', rankPill(rank), 100);
  });

  // On posts the badges list floats over the avatar, so show the pill in the header instead.
  extend(CommentPost.prototype, 'headerItems', function (items) {
    const rank = userRank(this.attrs.post && this.attrs.post.user());
    if (rank) items.add('jaecoo-rank', rankPill(rank), 95);
  });

  // Tag each post with the author's rank so CSS can tint the card, name and avatar.
  extend(CommentPost.prototype, 'classes', function (classes) {
    const rank = userRank(this.attrs.post && this.attrs.post.user());
    if (rank) classes.push(`Post--rank-${rank.key}`);
  });
}
